const AMOUNT = "amount"
const UOM = "unit"
const INGREDIENT = "name"

const PLACEHOLDER = {
	ING: "Ingredient",
	UOM: "Unit of Measure"
}

const values = (ls) => ls.map(entry => entry.value)

const validateAndFormat = (name, instructions, ingList) => {

	if (!name) return { error: "Title" }
	if (!instructions) return { error: "Instructions" }

	const ingredients = values(ingList).filter(i => i['amount'] && i['name']).map(i => ({
		...i,
		amount: +i.amount
	}))
	if (!ingredients) return { error: "Ingredients" }

	return {
		valid: true,
		requestBody: {
			name,
			instructions,
			ingredients
		}
	}
}

export {
	AMOUNT,
	INGREDIENT,
	PLACEHOLDER,
	UOM,
	validateAndFormat
}
